export default __webpack_public_path__ + "static/media/presentation.4b4924e9.pptx";